import { Badge, Text, WrapperFlex } from '@unimed-fesp/components';
import * as jwtDecode from 'jwt-decode';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Creators as ListaActions } from '../../../store/ducks/lista';
import { isContratanteNestle } from '../../../utils/userRole';
import LoadingSpinner from '../LoadingSpinning';
import { ButtonContainer } from './styles';

export default function StatusList() {
  const dispatch = useDispatch();
  const { statusLists, listas } = useSelector((state) => state.lista);
  const { usuario } = useSelector((state) => state.auth);
  const { accessToken } = useSelector((state) => state.auth);

  const { IsAdm } = jwtDecode(accessToken);

  const params = {
    page_number: 0,
    page_size: 10,
    is_nestle_query: isContratanteNestle(usuario),
    movement_list_filter: {
      is_admin: usuario.role === 'Adm',
      status: [],
      list_name: null,
      beneficiary_name_or_number_card: null,
      type_list: null,
      type_action: null,
      contractor_code:
        usuario.role === 'Adm' || isContratanteNestle(usuario)
          ? null
          : usuario.codigoContratante,
      modality_code: null,
      term_code: null,
      expired: false,
      r_n412: false,
      file_name_movement: null,
      start_created_date: null,
      end_created_date: null,
      start_update_date: null,
      end_update_date: null,
      show_fake_list: IsAdm.toLowerCase() === 'true',
    },
  };

  useEffect(() => {
    if (usuario.codigoContratante && !isContratanteNestle(usuario)) {
      dispatch(
        ListaActions.getStatusListContratanteRequest(
          usuario.codigoContratante,
          IsAdm.toLowerCase() === 'true'
        )
      );
    } else if (isContratanteNestle(usuario)) {
      dispatch(
        ListaActions.getStatusListNestleRequest(IsAdm.toLowerCase() === 'true')
      );
    } else {
      dispatch(ListaActions.getStatusListAdminRequest());
    }
  }, []);

  function handleActiveSearches(index) {
    const active = statusLists.response.actives[index];
    const todosActive = statusLists.response.actives.find(
      (status, i) => status.description === 'Todos'
    );
    const availableTodos = statusLists.response.availables.filter(
      (status, i) => status.description !== 'Todos'
    );

    if (active.description === 'Todos') {
      const response = {
        availables: [
          ...statusLists.response.actives,
          ...statusLists.response.availables,
        ],
        actives: [],
      };
      const idActives = response.actives
        .filter((status) => status.description !== 'Todos')
        .map((status) => status.id);

      params.movement_list_filter.status = idActives;
      return ListaActions.getStatusListAdminResponse(response, true);
    }

    if (todosActive && availableTodos) {
      const restTodos = statusLists.response.actives.filter(
        (status, i) =>
          status.description !== 'Todos' &&
          status.description !== active.description
      );
      const response = {
        availables: [todosActive, active, ...statusLists.response.availables],
        actives: restTodos,
      };
      const idActives = response.actives
        .filter((status) => status.description !== 'Todos')
        .map((status) => status.id);

      params.movement_list_filter.status = idActives;
      return ListaActions.getStatusListAdminResponse(response, true);
    }

    const newActiveSearches = statusLists.response.actives.filter(
      (_, i) => i !== index
    );
    const response = {
      availables: [...statusLists.response.availables, active],
      actives: newActiveSearches,
    };

    const idActives = response.actives
      .filter((status) => status.description !== 'Todos')
      .map((status) => status.id);

    params.movement_list_filter.status = idActives;
    return ListaActions.getStatusListAdminResponse(response, true);
  }

  function handleAvailableSearches(index) {
    const available = statusLists.response.availables[index];
    const restTodos = statusLists.response.availables.filter(
      (status, i) => status.id !== 0 && status.count !== 0
    );

    const nonZeroItems = statusLists.response.availables.filter(
      (item) => item.count !== 0
    );
    const zeroItems = statusLists.response.availables.filter(
      (item) => item.count === 0
    );

    if (restTodos.length === 1) {
      const response = {
        availables: [...zeroItems],
        actives: [...nonZeroItems, ...statusLists.response.actives],
      };

      const idActives = response.actives
        .filter((status) => status.description !== 'Todos')
        .map((status) => status.id);

      params.movement_list_filter.status = idActives;

      return ListaActions.getStatusListAdminResponse(response, true);
    }

    if (available.id === 0) {
      const response = {
        availables: [...zeroItems],
        actives: [...nonZeroItems, ...statusLists.response.actives],
      };

      const idActives = response.actives.map((status) => status.id);

      params.movement_list_filter.status = idActives;

      return ListaActions.getStatusListAdminResponse(response, true);
    }

    const newAvailableSearches = statusLists.response.availables.filter(
      (_, i) => i !== index
    );

    const response = {
      availables: newAvailableSearches,
      actives: [...statusLists.response.actives, available],
    };

    const idActives = response.actives
      .filter((status) => status.description !== 'Todos')
      .map((status) => status.id);

    params.movement_list_filter.status = idActives;

    return ListaActions.getStatusListAdminResponse(response, true);
  }

  function handleClickAvailable(index) {
    dispatch(handleAvailableSearches(index));
    dispatch(ListaActions.postSearchListRequest(params));
  }

  function handleClickActive(index) {
    const active = statusLists.response.actives[index];
    if (active.description === 'Todos') {
      dispatch(
        ListaActions.postSearchListResponse(
          { totalCount: 0, data: [], totalPages: 0 },
          true
        )
      );
      return dispatch(handleActiveSearches(index));
    }
    if (statusLists.response.actives.length <= 1) {
      dispatch(
        ListaActions.postSearchListResponse(
          { totalCount: 0, data: [], totalPages: 0 },
          true
        )
      );

      return dispatch(handleActiveSearches(index));
    }
    dispatch(handleActiveSearches(index));
    dispatch(ListaActions.postSearchListRequest(params));
  }

  if (listas.loading || statusLists.loading) {
    return (
      <WrapperFlex
        marginTop={16}
        gap={5}
        marginBottom={16}
        justifyStart
        alignCenter
        flexWrap
        column
      >
        <Text size={20} bold text="Carregando Listas..." />
        <LoadingSpinner height={10} />
      </WrapperFlex>
    );
  }
  return (
    <>
      <WrapperFlex marginTop={16} gap={5} justifyStart alignStart flexWrap>
        {statusLists.response.availables.map(
          ({ id, description, count }, index) => (
            <ButtonContainer key={id}>
              <Badge
                onClick={() => handleClickAvailable(index)}
                color={'#ababab'}
                cursorPointer
                text={`${description} (${count})`}
                showBtnRemove={count > 0}
              />
            </ButtonContainer>
          )
        )}
      </WrapperFlex>
      <WrapperFlex
        marginTop={16}
        marginBottom={16}
        gap={5}
        justifyStart
        alignStart
        flexWrap
      >
        <Text text="Filtros aplicados:" />
        {statusLists.response.actives.map(
          ({ id, description, count }, index) => (
            <ButtonContainer key={id}>
              <Badge
                onClick={() => handleClickActive(index)}
                text={`${description} (${count})`}
              />
            </ButtonContainer>
          )
        )}
      </WrapperFlex>
    </>
  );
}
